import { css } from 'linaria';

export const entranceDoorsGallerySectionTitle = css`
  width: 776px;
  margin-bottom: 24px;

  @media (--only-desktop) {
    width: 616px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const entranceDoorsGallerySectionList = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0;
  margin: 0;
  margin-bottom: 24px;
  column-gap: 24px;
  list-style: none;

  @media (--only-tablet) {
    column-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: auto;
    column-gap: 0;
    row-gap: 16px;
  }
`;

export const entranceDoorsGallerySectionPointName = css`
  margin-top: 16px;
`;

export const entranceDoorsGalleryGrid = css`
  && {
    @media (--only-tablet) {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }

    > div {
      @media (--only-tablet) {
        height: 216px;
      }
    }

    div:nth-of-type(10n -5),
    div:nth-of-type(10n -2) {
      @media (--only-tablet) {
        height: 456px;
      }
    }
  }
`;
